import { EmailValidationStrings } from 'utils/strings';
import * as yup from 'yup';

export const loginSchema = yup.object({
  username: yup.string().email().required(),
  password: yup.string().required(),
});
export const changePasswordSchema = yup.object().shape({
  oldPassword: yup.string().required(),
  newPassword: yup
    .string()
    .min(8, 'Hasło musi mieć co najmniej 8 znaków')
    .matches(
      /^(?=.*[A-Z])(?=.*[!.@#$%^&*])(?=.*[0-9a-z]).{0,}$/,
      'Hasło musi zawierać co najmniej jedną wielką literę, jeden znak specjalny'
    ),
});

export const resetPasswordSchema = yup.object().shape({
  value: yup
    .string()
    .min(8, 'Hasło musi mieć co najmniej 8 znaków')
    .matches(
      /^(?=.*[A-Z])(?=.*[!.@#$%^&*])(?=.*[0-9a-z]).{0,}$/,
      'Hasło musi zawierać co najmniej jedną wielką literę, jeden znak specjalny'
    ),
});

export const emailSchema = yup.object().shape({
  value: yup
    .string()
    .matches(/[^$]/, EmailValidationStrings.empty)
    .matches(/@/, EmailValidationStrings.missingAT)
    .matches(/@+\S/, EmailValidationStrings.missingDomain)
    .matches(/^\S+@+/, EmailValidationStrings.missingPrefix)
    .matches(/^[^@]*@[^+@]*$/, EmailValidationStrings.specialinDomain)
    .matches(/^([^@]*@){1}[^@]*$/, EmailValidationStrings.doubleATs)
    .matches(/^[^.].*$/, EmailValidationStrings.startsWithDot)
    .matches(
      /^(?!.*[!#$%^&*()_\-=[\]{};':"\\|,<>/?]).*$/,
      EmailValidationStrings.specials
    )
    .matches(
      /^(?!.*[!@#$%^&*()_\-=[\]{};':"\\|,.<>/?]{2}).*$/,
      EmailValidationStrings.multipleSpecials
    )
    // eslint-disable-next-line no-control-regex
    .matches(/^[\x00-\x7F]*$/, EmailValidationStrings.nonAscii)
    .matches(
      /@+([a-zA-Z\-0-9])+\.+([a-zA-Z\-0-9])/,
      EmailValidationStrings.missingTopLevelDomain
    )
    .matches(
      /@+([a-zA-Z\-0-9])+\.+([a-zA-Z\-0-9]{2,})/,
      EmailValidationStrings.topLevelDomain
    )
    .required('Wymagane!'),
});
